module.exports = __webpack_public_path__ + "media/images/featured-1-desktop-4feddd05d529c2802478356ab28fbae8.webp";